(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalFirm', AppraisalFirm);

    AppraisalFirm.$inject = ['$resource'];

    function AppraisalFirm ($resource) {
        var resourceUrl =  'api/appraisal-firms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'registerFirm' : { method: 'POST', url: 'api/appraisal-firms/register'},
            'getDropDownAppraisalFirms': { method:'GET', url:'api/appraisal-firms-minimal', isArray: true },
            'getProofOfInsuranceSummary': { method:'GET', url:'api/appraisal-firms/proof-of-insurance-summary', isArray: true },
            'addLenderToAppraisers': { method: 'POST', url: 'api/appraisal-firms/:id/add-lender/:lenderId' },
            'removeLenderFromAppraisers': { method: 'POST', url: 'api/appraisal-firms/:id/remove-lender/:lenderId' },
            'uploadProofOfInsurance': {
                method: 'POST',
                url: 'api/appraisal-firms/:id/proof-of-insurance',
                headers: { 'X-Skip-Success-Alert': 'true' },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'deleteProofOfInsurance': {
                method: 'DELETE',
                url: 'api/appraisal-firms/:id/proof-of-insurance/:fileId',
                headers: { 'X-Skip-Success-Alert': 'true' }
            }
        });
    }

})();
